import React from "react";
import PropTypes from "prop-types";
import ControlResolver from "../ControlResolver";
import {controlPropTypes} from "../formhelpers";

class Form extends React.Component {
    render() {
        const {
            descriptor,
            propsResolver
        } = this.props;
        return descriptor.childItems.map((itemDescriptor) => {
            const controlProps = {
                ...this.props,
                propsResolver,
                descriptor: itemDescriptor, // overload descriptor
                ...propsResolver(itemDescriptor) // overload any props based on propsResolver()
            };
            const Control = ControlResolver(controlProps.descriptor);

            return (
                <Control
                    key={controlProps.descriptor.key}
                    {...controlProps}
                />
            );
        });
    }
}

Form.defaultProps = {
    descriptor: {},
    controlOnly: false,
    placeholder: false,
    childItems: []
};

Form.propTypes = {
    ...controlPropTypes(null, false, true),
    propsResolver: PropTypes.func.isRequired,
    onCommitChange: PropTypes.func, // not required
};

export default Form;



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/Form/form.js